import React from "react";
import { AppProvider } from "./context/app-context";
import App from "./App";


export function AppFactory() {

    return (
        <AppProvider>
         <App />
        </AppProvider>
    );
}